/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Country_RequiredInputs */



/**
* | output |
* | --- |
* | "A group needs a country: unpinned, it shows in that country's card." |
*
* @param {Community_Link_Country_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_country_required = /** @type {((inputs?: Community_Link_Country_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Country_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un groupe doit indiquer un pays : non épinglé, il apparaît dans la carte de ce pays.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un grupo necesita un país: sin fijar, aparece en la tarjeta de ese país.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um grupo precisa de um país: sem fixação, ele aparece no cartão desse país.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un gruppo deve indicare un paese: se non è fissato, compare nella scheda di quel paese.")
	return /** @type {LocalizedString} */ ("A group needs a country: unpinned, it shows in that country's card.")
});